import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row footer-top">

          {/* Left */}
          <div className="col-md-6 footer-about">
            <h5>WasteWatch</h5>
            <p>
              A smart platform designed to make urban cleanliness easier.
            </p>
          </div>

          {/* Right */}
          <div className="col-md-6 footer-right">
            
            

            <div className="footer-social">
              <h5>Social Media</h5>
              <div className="social-icons">
                <a href="https://facebook.com" className="facebook"><FaFacebookF /></a>
                <a href="https://twitter.com" className="twitter"><FaTwitter /></a>
                <a href="https://instagram.com" className="instagram"><FaInstagram /></a>
              </div>
            </div>

          </div>
        </div>

        {/* Copyright – ALWAYS LAST */}
        <div className="copyright-footer">
          © 2025 WasteWatch
        </div>
      </div>
    </footer>
  );
};

export default Footer;
